var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player"},[_c('video',{staticClass:"video-player-item",attrs:{"controls":"","disablePictureInPicture":"","controlsList":"nodownload"}},[_c('source',{attrs:{"src":_vm.file.link,"type":_vm.mimeType}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }